import { ProductCategory } from "../../Models/Product/ProductCategory";
import { HtmlArticle } from "../../Components/Product/Card";
import { Div, Link, Paragraph, Span } from "@tblabs/truffle";
import { CardFigure } from "../../Components/Product/CardFigure";
import { Svg } from "../Components/Utils/Svg";
import { Icons } from "../../Components/Utils/Icons";
import { ShopContentProvider } from "../../Services/Content/ShopContentProvider";


export class ProductCategoryBox extends HtmlArticle
{
    constructor(category: ProductCategory, _shop: ShopContentProvider)
    {
        super("product-card group");

        this.OnClick(() => window.location.hash = "kategoria/" + category.Url.value)

        const pricePerDay = _shop.GetLowestPriceForProductFromCategory(category);

        this.Append(
            new Link("", category.Url.value).Class("product-card__link")
                .Append(
                    new CardFigure(category.Image.value),
                    new Div("product-card__content").Append(
                        new Div("product-card__title")
                            .Id(`product-${category.Title.value.toLowerCase()}`)
                            .Text(category.Title.value),
                        new Paragraph("product-card__description").Text(category.Subtitle.value),
                        new Div("product-card__footer").Append(
                            pricePerDay && new Paragraph("product-card__price").Text(pricePerDay),
                            new Div("product-card__button")
                                .Attribute("aria-hidden", "true")
                                .Append(
                                    new Span("Zobacz więcej"),
                                    new Svg(Icons.ArrowRight),
                                )
                        ), // product-card__footer
                    ), // product-card__content
                )
        );
    }
}
